import { Routes, Route, Navigate } from 'react-router-dom';
import { BodyLayout } from './components/BodyLayout/BodyLayout';
import { Header } from './components/Header/Header';
import { Login } from './components/Login/Login';
import { Home } from './components/Home/Home';
import { Profile } from './components/Profile/Profile';
import { Plans } from './components/Plans/Plans';
import { Team } from './components/Team/Team';
import { useAuth } from './context/AuthContext';
import { Settings } from './components/Settings/Settings';
import { Restore, RestoreData } from './components/Restore/Restore';
import { GlobalSettings} from './components/GlobalSettings/GlobalSettings';
import { RequireAuth } from './Auth/RequireAuth';
import { SuperAdminOrAdminOrUserEditAccess } from './Auth/SuperAdminOrAdminOrUserEditAccess';
import { Builders } from './components/Builders/Builders';
import { ArchivePlans } from './components/Plans/ArchivedPlans';
import { ResetPassword } from './components/ResetPassword/ResetPassword';
import { PassChange } from './components/PassChange/PassChange';

// This layout includes the Header 
function LayoutWithHeader() {  
  const auth = useAuth();

  return (
    <>
      <Header />
      <Routes>
        <Route path="/home" element={<Home />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/plans" element={<Plans />} />
        <Route path="/archived-plans" element={<ArchivePlans/>} />
        <Route element={<SuperAdminOrAdminOrUserEditAccess/>}>
          <Route path="/settings" element={<Settings />} />
          <Route path="/builders" element={<Builders />} />
          <Route path="/team" element={<Team />} />
          <Route
            path="/superadmin/*"
            element={
              auth.userRole === "superadmin" &&
              localStorage.getItem("orgId") === "84a4c617-0681-4a75-b6d7-bcaeca5a95a9"
                ? <Restore />
                : <Navigate to="/plans" replace />
            }
          >
            <Route path="restoredata" element={<RestoreData />} />
            <Route path="globalsettings" element={<GlobalSettings />} />
          </Route>
        </Route>
      </Routes>
    </>
  );
}

function App() {
  return (
    <BodyLayout>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/resetpass" element={<ResetPassword/>} />
        <Route path="/passchange" element={<PassChange/>} />
        {/* All other routes go inside this layout that includes Header */}
        <Route element={<RequireAuth/>}>
          <Route path="/*" element={<LayoutWithHeader />} />
        </Route>
      </Routes>
    </BodyLayout>
  );
}

export default App;
